import React, { useState, useEffect,useContext } from "react";
import { AppContext } from "../../AppContext";

import { HandleStatusCodeThenJson } from "../../common/FetchHelpers";
import DateUtil from "../../common/dateUtil";
import LoadingComp from "../common/LoadingComp";

import ReqControlHeader from "../common/ReqControlHeader";

import PoliticalSearchComp from "./PoliticalSearchComp";
import PoliticalEditorComp from "./PoliticalEditorComp";
import { fetchCall } from "../../common/FetchHelpers";

const PoliticalComp = (props) => {

  const summaryUrl = "api/political/reqsummary";

  const [appContext, setAppContext] = useContext(AppContext);
  
  
  const emptyEditorItem = {
    id:-1,
    status:"",
    contribType : "Contribution",
    description : "",
    contribAmount:"",
    currency:"",
    contribDate : "",
    reqMsrb:"N",
    isCampaign:"N",
    campaign:"",
    stateProv:"",
    politicalParty:"",
    attachment:null,
    officials:[
      {name:'',title:'',agency:''},
      {name:'',title:'',agency:''}
    ],

    contributorType:"",
    spouseLastName:"",
    spouseMiddleName:"",
    spouseFirstName:"",
    contribTarget:"",
    politicalOrganizationType:"",
    politicalPartyVoteJurisdiction:"",
    politicalOrganizationName:"",
    politicalOrganizationJurisdiction:"",
    candidateName:"",
    officeSought:"",
    electionDate:"",
    officeSoughtJurisdiction:"",
    electionType:"",
    officeHeld:"",
    contribPaymentType:"",
    candidateContribAmount:"",
    otherPaymentMethod:"",
    otherContribMethod:"",
    contributePersonalFund:"",
    engagementInWorkingHours:"",
    engagementHours:"",
    usingOfficeResource:"",
    contribIndividualOrPac:"",
    contribIndividualSoughtPosition:"",
    contribIndividualHoldOffice:"",
    contribIndividualActivePosition:"",
    contributorEligibleToVote:"N",

    isIndividualPriorContrib:"",
    individualPriorContribDetail:"",
    individualPriorContribDate:"",
    individualPriorContribAmount:"",
    individualPriorContribCampaignOrganization:"",
    isCandidateAssociated:"",
    candidateAssociatedDesc:"",
    isCandidateClient:"",

    submittedFor:null
  }
  
  const [showingList, setShowingList] = useState(true);
  const [showingEditor, setShowingEditor] = useState(false);
  const [showError, setShowError] = useState(false);
  const [loading, setLoading] = useState(false);
  const [editorItem, setEditorItem] = useState(emptyEditorItem);
  const [editorMode, setEditorMode] = useState("NEW");
    
  const addNewClickHandler = () => {
    setEditorItem(emptyEditorItem);
    setControlParam((p) => {
      return { ...p, mode: "add" };
    });
    
    
    setShowingList(false);
    setShowingEditor(true);
  };

  const showListHandler = () => {
    setControlParam((p) => {
      return { ...p, mode: "view" };
    });
    setShowingEditor(false);
    setShowingList(true);
  };
  
  const handleUpdate=(data)=>{
    console.log(data);
    setEditorMode("UPDATE");
    const contribDate = DateUtil.toDate(data.contribDate);
    const electionDate = data.electionDate?DateUtil.toDate(data.electionDate):null;
    const individualPriorContribDate = data.individualPriorContribDate?DateUtil.toDate(data.individualPriorContribDate):null;
    
    const item = {
      ...data,
      contribDate,
      electionDate,
      individualPriorContribDate,
      isCampaign:data.campaign===null?"N":"Y",
        campaign:data.campaign===null?"":data.campaign
      };
      
      console.log(item);
      
      setEditorItem(item);
      setShowingList(false);
      setShowingEditor(true);
  };

  const [controlParam, setControlParam] = useState({
    approved: 0,
    pending: 0,
    rejected: 0,
    btnAddLabel: "Create a New Request",
    mode: "view",
    addNewClickHandler,
    showListHandler,
  });


  useEffect(() => {

    fetchCall(summaryUrl)
      .then((result)=>{
        setControlParam({
          ...controlParam,
          approved: result.politicalRequest.approved,
          pending: result.politicalRequest.pending,
          rejected: result.politicalRequest.rejected,
        });
        setLoading(false);

      },
      (err)=>{
        setLoading(false);
        setShowError(true);
      }
    );
  }, [appContext.reloadSummary]);


  return (
    <div className={appContext.sidebarCollapsed?"content-wrapper sidebar-collapsed":"content-wrapper"}>
      <section className="section-wrapper">
        <div className="page-title">Political Contribution & Charitable Donations Request</div>
        <div className="section-content">
          <ReqControlHeader params={controlParam} />
          <div className="section-body">
            {showingList && <PoliticalSearchComp handleUpdate={handleUpdate} politicalId={props.match.params.id} t={props.match.params.t} />}
            {showingEditor && <PoliticalEditorComp handleClose={showListHandler} formData={editorItem} editorMode={editorMode}/>}
            {/* {showError && <ErrorComp />} */}
            {loading && <LoadingComp />}
          </div>
        </div>
      </section>
    </div>
  );
};

export default PoliticalComp;
